// extracted by mini-css-extract-plugin
export default {"indicators":"SensorChart_indicators__QQofU"};